<template>
  <div id="app">
    <router-view></router-view>
<!--
    <div class="sign-out">
      <amplify-sign-out v-if="$Session.user"></amplify-sign-out>
    </div>
-->
  </div>
</template>

<script>
import { AmplifyEventBus } from "aws-amplify-vue";
import { Auth } from "aws-amplify";
import Vue from "vue";

export default {
  name: "app",
  async beforeCreate() {

    AmplifyEventBus.$on("authState", info => {
      this.$c.log("App.vue AmplifyEventBus.$on('authState'");
      if (info === "signedIn") {
        this.$c.log("App.vue beforeCreate AmplifyEventBus.$on(authState) Auth.currentAuthenticatedUser()");
        Auth.currentAuthenticatedUser()
          .then(user => {
            if (user) {
              this.$Session.user = user;
              this.$c.log("App.vue | AmplifyEventBus | Auth.currentAuthenticatedUser() success!", this.$Session.user);

              let newRoute = this.$route.fullPath;

              if (this.$route.query.redirect) {
                newRoute = decodeURIComponent(this.$route.query.redirect);
              }
              this.$c.log("App.vue | AmplifyEventBus | Auth.currentAuthenticatedUser() redirecting to:" + newRoute);
              this.$router.push(newRoute);
            }
          })
          .catch(e => {
            this.$c.log("App.vue | AmplifyEventBus | Auth.currentAuthenticatedUser() failure", e);
          });
      }
      if (info === "signedOut") {
        this.$router.push("/login");
        this.$Session.user = null;
        this.$Session.groups = []; 
        this.$Session.userId = '';        
      }
    });// End AmplifyEventBus.$on

  },
  data() {
    return {};
  }
};
</script>
